export const selectNotificationsList = state =>
    state.notifications.notificationsList;

export const selectDetailedNotification = state => state.notifications.detailedNotification;

export const selectUnreadCount = state => state.notifications.unreadCount;

export const selectIsLoading = state => state.notifications.isLoading;

export const selectError = state => state.notifications.error;

export const selectToasts = state => state.notifications.toasts;

export const selectIsPopupOpen = state => state.notifications.isPopupOpen;
